'use client';

import { FunctionComponent, useState } from 'react';
import Questions, { QuestionTypes } from './Questions';
import styles from './styles.module.scss';
import CircleMinusRegularIcon from '../Icons/CircleMinusRegularIcon';
import CirclePlusRegularIcon from '../Icons/CirclePlusRegularIcon';

const Faq: FunctionComponent<{ faq: QuestionTypes }> = ({ faq }) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <div className={styles.faq} key={faq.question}>
            <button
                className={styles.faq_question}
                key={faq.question}
                aria-expanded={expanded}
                aria-controls={faq.question}
                aria-labelledby={faq.question}
                onClick={() => setExpanded(!expanded)}
            >
                {faq.question}
                {expanded ? (
                    <CircleMinusRegularIcon height={24} width={24} fill="var(--icon-fill-light)" />
                ) : (
                    <CirclePlusRegularIcon height={24} width={24} fill="var(--icon-fill-light)" />
                )}
            </button>
            {expanded ? (
                <p className={styles.faq_answer} role="region" aria-labelledby={faq.question}>
                    {faq.answer}
                </p>
            ) : null}
        </div>
    );
};

const FAQs: FunctionComponent<{}> = () => {
    return (
        <>
            {Questions.map((faq, i) => (
                <Faq key={i} faq={faq} />
            ))}
        </>
    );
};

export default FAQs;
